<template>
  <el-dialog title="我的发起" :visible.sync="show" top="5vh" width="1200px" center :close-on-click-modal="true" :close-on-press-escape="false">
    <div class="w100" v-loading="loading">
      <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
        <el-col class="flex-box al-c" :span="4">
          <el-button type="primary" @click="initPage">搜索</el-button>
        </el-col>
      </Sift>

      <el-table class="w100 mt20 table" header-row-class-name="table-head" row-class-name="cu-p" height="calc(90vh - 300px)" stripe :data="list" @row-click="clickRow">
        <el-table-column align="center" label="序号" width="50px">
          <template slot-scope="scope">
            {{ pageNum * pageSize - pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="serveName" label="类型"></el-table-column>
        <el-table-column align="center" prop="taskTitle" label="标题"></el-table-column>
        <el-table-column align="center" prop="content" label="内容" v-if="hasContent"></el-table-column>
        <el-table-column align="center" label="申请时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm') }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createUserName" label="申请人"></el-table-column>
        <!-- <el-table-column align="center" prop="actionName" label="操作状态" width="150"></el-table-column> -->
        <el-table-column align="center" prop="processState" label="办理状态"></el-table-column>
      </el-table>

      <div class="mt20 flex-box">
        <div class="flex-1"></div>
        <el-pagination background @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>

    <IframeView ref="iframeView" :append-to-body="true" @init-page="initPage" @fetch-list="fetchList" />
  </el-dialog>
</template>

<script>
import Sift from "@/components/sift/Sift";
import IframeView from "@/components/public/IframeView";

export default {
  name: "DialogLaunch",
  components: {
    Sift,
    IframeView
  },
  props: [],
  data() {
    return {
      show: false,

      loading: false,
      siftData: [],
      list: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      hasContent: false
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    fetchSiftData() {
      this.loading = true;
      this.$http
        .post("/baseTask/queryHasLaunchTask")
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.siftData = data.resData.siftData;
            this.$nextTick(() => {
              this.initPage();
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchList() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.needSift.getValue();
      }
      obj.pageNum = this.pageNum;
      obj.pageSize = this.pageSize;
      this.loading = true;
      this.$emit("fetch-msg-count");

      this.$http
        .post("/baseTask/queryHasLaunch", this.$qs.stringify(obj))
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.list = data.resData.list;
            this.total = data.resData.total;
            this.hasContent =
              this.list.length && this.list[0].content ? true : false;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    initPage() {
      this.pageNum = 1;
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    showView() {
      this.show = true;
      if (this.siftData.length == 0) {
        this.fetchSiftData();
      } else {
        this.initPage();
      }
    },
    clickRow(item) {
      this.$refs.iframeView.showView(item.taskUrl, item.taskInstId);
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
